import type { Types } from '@fiverr-private/theme';
import type { AvatarSizeType, SquareRadiuses } from './types';

export const RING_BORDER_WIDTH = 8;
export const AI_RING_BORDER_WIDTH = 4;
export const RING_STROKE_WIDTH = 2;

export const AVATAR_COLORS = [
    'blue_light',
    'blue_dark',
    'pink_light',
    'pink_dark',
    'green_light',
    'green_dark',
    'yellow_light',
    'yellow_dark',
    'orange_light',
    'orange_dark',
    'lime_light',
    'lime_dark',
    'red_light',
    'red_dark',
] as const;

export const FONT_SIZES: { [key in AvatarSizeType]: Types.BoxType['fontSize'] } = {
    xs: 'b_xs',
    sm: 'b_md',
    md: 'b_xl',
    lg: 'h_lg',
    xl: 'h_xxl',
    '2xl': 'h_xxl',
    '3xl': 'h_3xl',
    '4xl': 'h_3xl',
};

export const AVATAR_COLOR_SCHEME: {
    [key in (typeof AVATAR_COLORS)[number]]: {
        fontColor: Types.Color;
        backgroundColor: Types.BackgroundColor;
    };
} = {
    blue_light: {
        backgroundColor: 'blue_200',
        fontColor: 'blue_1100',
    },
    blue_dark: {
        backgroundColor: 'blue_1100',
        fontColor: 'blue_200',
    },
    pink_light: {
        backgroundColor: 'pink_200',
        fontColor: 'pink_1100',
    },
    pink_dark: {
        backgroundColor: 'pink_1100',
        fontColor: 'pink_200',
    },
    green_light: {
        backgroundColor: 'green_200',
        fontColor: 'green_1100',
    },
    green_dark: {
        backgroundColor: 'green_1000',
        fontColor: 'green_200',
    },
    yellow_light: {
        backgroundColor: 'yellow_200',
        fontColor: 'yellow_1100',
    },
    yellow_dark: {
        backgroundColor: 'yellow_1200',
        fontColor: 'yellow_200',
    },
    orange_light: {
        backgroundColor: 'orange_200',
        fontColor: 'orange_1100',
    },
    orange_dark: {
        backgroundColor: 'orange_1100',
        fontColor: 'orange_200',
    },
    lime_light: {
        backgroundColor: 'lightOrange_200',
        fontColor: 'lightOrange_1100',
    },
    lime_dark: {
        backgroundColor: 'lightOrange_1100',
        fontColor: 'lightOrange_200',
    },
    red_light: {
        backgroundColor: 'red_200',
        fontColor: 'red_1100',
    },
    red_dark: {
        backgroundColor: 'red_1100',
        fontColor: 'red_200',
    },
};

export const DEFAULT_COLOR: {
    fontColor: Types.Color;
    backgroundColor: Types.BackgroundColor;
} = {
    backgroundColor: 'grey_400',
    fontColor: 'grey_1000',
};

export const AVATAR_SIZES = {
    xs: 24,
    sm: 32,
    md: 48,
    lg: 64,
    xl: 80,
    '2xl': 96,
    '3xl': 120,
    '4xl': 160,
} as const;

export const AVATAR_SQUARE_RADIUS_BY_SIZE: {
    [key in (typeof AVATAR_SIZES)[keyof typeof AVATAR_SIZES]]: SquareRadiuses;
} = {
    24: 'sm',
    32: 'sm',
    48: 'md',
    64: 'lg',
    80: 'lg',
    96: 'xl',
    120: '2xl',
    160: '2xl',
} as const;

export const AVATAR_SQUARE_OFFSET_BY_SIZE: { [key in (typeof AVATAR_SIZES)[keyof typeof AVATAR_SIZES]]: number } = {
    24: 22,
    32: 30,
    48: 46,
    64: 62,
    80: 76,
    96: 92,
    120: 116,
    160: 156,
} as const;

export const HALF = 0.5;
